import Swiper, { Navigation } from "swiper";
import { $Q, $Qll } from "../utils/query-selector";

const initOurTeamSlider = () => {
  const sliderEl = $Q(".our-team__slider");
  const sliderItems = $Qll(".our-team__slide");

  if (!sliderEl) return;

  if (sliderItems.length <= 1) return;

  // eslint-disable-next-line no-new
  new Swiper(sliderEl, {
    modules: [ Navigation ],
    slidesPerView: 1,
    cssMode: true,
    spaceBetween: 0,
    loop: false,
    navigation: {
      prevEl: '.our-team--prev',
      nextEl: '.our-team--next',
    },
    autoplay: false,
  });
};

export default initOurTeamSlider;
